import { gql } from "graphql.macro";

export const queryPdpDeliveryMethods = gql`
  query queryPdpDeliveryMethods($itemPath: String = "/sitecore/content/lynkco-global-portal/Global Setting/Pdp Delivery Methods", $language: String = "en") {
    obj: item(path: $itemPath, language: $language) {
      list: children {
        ...deliveryMethod
      }
    }
  }
  fragment deliveryMethod on PdpDeliveryMethod {
    key {
      value
    }
    label {
      value
    }
    body {
      value
    }
    closeText {
      value
    }
  }
`;
